import type { Feature } from '@luna/gatekeeper';

export const autoRepayment: Feature = {
    enabled: true,
    _description: 'Displays auto-repayment card in the credit card functions page',
};
